module.exports = __webpack_public_path__ + "img/bmw_logo.9437e914.png";